import { render, staticRenderFns } from "./BusRiskAreaConfigModal.vue?vue&type=template&id=6fe273e8&"
import script from "./BusRiskAreaConfigModal.vue?vue&type=script&lang=js&"
export * from "./BusRiskAreaConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports